var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"brand-logo",attrs:{"to":"/"}},[(!_vm.domainBasedBrand)?_c('div',[_c('svg',{attrs:{"width":"125","height":"40","fill":"none"}},[_c('use',{attrs:{"xlink:href":"#brandLogo"}})])]):_c('div',[_c('img',{staticClass:"img-fluid logo-image-header",class:{
        'short-logo': _vm.$route.name !== 'home',
        'mobile-logo': _vm.currentBrand.web_logo_issqr,
      },style:({
        borderRadius:
          _vm.currentBrand.web_logo_issqr && _vm.$route.name === 'home'
            ? '50%'
            : null,
      }),attrs:{"id":"logo","src":_vm.currentBrand.web_logo_issqr
          ? _vm.currentBrand.web_logo_sqr
          : _vm.currentBrand.web_logo}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }